import { store, itiHttpService, itiMessageService, itiSignalRService, ItiString } from '@/iti-core-vue';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { API } from '@/shared/api';
import { Notification } from '@/shared/dtos/notificacion';
import { CollaborativeArea } from '@/shared/dtos/collaborative-area';

@Module({
  namespaced: true,
  name: 'NotificationModule',
  store,
  dynamic: true,
})
class NotificationModule extends VuexModule {

  @Action
  public async markNotificationAsRead(idNotificacion: number) {
    const url = ItiString.Format('{0}', API.notifications);
    await itiHttpService.put(url, idNotificacion + '')
      .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
      .then((value) => {
        return value;
      });
  }
  @Action
  public async getNombreArea(ambitId: string) {
    const res: CollaborativeArea = await itiHttpService.get(API.collaborativeArea + '/(' + ambitId + ')');
    return res.name;
  }

}
export default getModule(NotificationModule);
